import { render, staticRenderFns } from "./Sticks.vue?vue&type=template&id=000869c3&"
import script from "./Sticks.vue?vue&type=script&lang=js&"
export * from "./Sticks.vue?vue&type=script&lang=js&"
import style0 from "./Sticks.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports